document.addEventListener("DOMContentLoaded", function () {
    const apiEndpoint = "https://blog.worshiphousekids.com/wp-json/wp/v2/posts";
    const blogPostsContainer = document.getElementById("blog-posts");
  
    if (!blogPostsContainer) {
      console.error("blogPostsContainer not found in the DOM.");
      return; // Exit if the container is not found
    }
  
    fetchBlogPosts(apiEndpoint, blogPostsContainer);
    updateSectionTitle(document.querySelector(".blog-posts-left h2"));
    openProductPage();
    setupScrollEndDetection();
  });
  function openProductPage() {
    document
      .querySelectorAll(".product-item, .featured-image")
      .forEach(function (item) {
        item.addEventListener("click", function () {
          var url = this.getAttribute("data-url");
          if (url) {
            window.location.href = url;
          }
        });
      });
  }
  function fetchBlogPosts(apiEndpoint, blogPostsContainer) {
    fetch(apiEndpoint)
      .then((response) => response.json())
      .then((data) => renderBlogPosts(data, blogPostsContainer))
      .catch((error) => {
        console.error("Error fetching blog posts:", error);
      });
  }
  
  function renderBlogPosts(posts, container) {
    posts.forEach((post) => {
      const cleanDescription = cleanPostDescription(post.excerpt.rendered);
      const imageUrl = getPostImageUrl(post);
      const postElement = createPostElement(post, cleanDescription, imageUrl);
  
      container.appendChild(postElement);
    });
  }
  
  function cleanPostDescription(description) {
    const decodedDescription = decodeHtmlEntities(description);
  
    return decodedDescription
      .replace(/\[.*?\]/g, "")
      .replace(/\[…\]/g, "...")
      .replace(/<[^>]*>?/gm, "");
  }
  
  function decodeHtmlEntities(text) {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = text;
    return tempElement.textContent || tempElement.innerText || "";
  }
  
  function getPostImageUrl(post) {
    if (
      post.yoast_head_json &&
      post.yoast_head_json.og_image &&
      post.yoast_head_json.og_image[0] &&
      post.yoast_head_json.og_image[0].url
    ) {
      return post.yoast_head_json.og_image[0].url;
    } else if (post.featured_media && post.featured_media > 0) {
      // Attempt to get the featured media image if available
      return `https://blog.shiftworship.com/wp-json/wp/v2/media/${post.featured_media}`;
    } else {
      return "//shift-worship.myshopify.com/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_440x264.gif";
    }
  }
  
  function createPostElement(post, description, imageUrl) {
    const postElement = document.createElement("div");
    postElement.className = "blog-post";
  
    const imageElement = createImageElement(post, imageUrl);
    const contentWrapper = createContentWrapper(post, description);
  
    const imageContentContainer = document.createElement("div");
    imageContentContainer.className = "image-content-container";
    imageContentContainer.appendChild(imageElement);
    imageContentContainer.appendChild(contentWrapper);
  
    postElement.appendChild(imageContentContainer);
  
    return postElement;
  }
  
  function createImageElement(post, imageUrl) {
    const imageElement = document.createElement("img");
    imageElement.src = imageUrl;
    imageElement.alt = decodeHtmlEntities(post.title.rendered);
    imageElement.className = "blog-post-image";
  
    // Add an error event listener to handle image load failures
    imageElement.onerror = function () {
      imageElement.src = "/cdn/shop/files/placeholder_large.png?v=1729589471";
    };
  
    return imageElement;
  }
  function createContentWrapper(post, description) {
    const contentWrapper = document.createElement("div");
    contentWrapper.className = "blog-post-content";
  
    const metaInfo = createMetaInfo(post);
    const titleElement = createTitleElement(post);
    const descriptionElement = createDescriptionElement(description);
    const readMoreLink = createReadMoreLink(post);
  
    contentWrapper.appendChild(metaInfo);
    contentWrapper.appendChild(titleElement);
    contentWrapper.appendChild(descriptionElement);
    contentWrapper.appendChild(readMoreLink);
  
    return contentWrapper;
  }
  
  function createMetaInfo(post) {
    const metaInfo = document.createElement("div");
    metaInfo.className = "blog-post-meta";
    metaInfo.innerHTML = `<span class="blog-date">${new Date(
      post.date
    ).toLocaleDateString()}</span> | <span>By ${decodeHtmlEntities(
      post.yoast_head_json?.author || "Unknown Author"
    )}</span>`;
  
    return metaInfo;
  }
  function createTitleElement(post) {
    const titleElement = document.createElement("h3");
    titleElement.className = "blog-title";

    // Decode the title and limit to 30 characters
    const decodedTitle = decodeHtmlEntities(post.title.rendered);
    if (decodedTitle.length > 30) {
        titleElement.textContent = decodedTitle.slice(0, 30) + "..."; // Add "..." if it exceeds 30 characters
    } else {
        titleElement.textContent = decodedTitle; // Use the full title if within the limit
    }

    return titleElement;
}
  
  function createDescriptionElement(description) {
    const descriptionElement = document.createElement("p");
    descriptionElement.className = "blog-description";

    // Split the description into words
    const words = description.split(" ");
    // Check if the word count exceeds 20
    if (words.length > 10) {
        // Join the first 20 words and add "..."
        descriptionElement.textContent = words.slice(0, 15).join(" ") + "...";
    } else {
        // If 20 words or fewer, use the full description
        descriptionElement.textContent = description;
    }

    return descriptionElement;
}
  
  function createReadMoreLink(post) {
    const readMoreLink = document.createElement("a");
    readMoreLink.className = "read-more";
    readMoreLink.href = post.link;
    readMoreLink.target = "_blank";
    readMoreLink.innerHTML =
      'Read More <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.4997 3C14.4997 2.86739 14.447 2.74021 14.3532 2.64645C14.2594 2.55268 14.1323 2.5 13.9997 2.5H7.99965C7.86705 2.5 7.73987 2.55268 7.6461 2.64645C7.55233 2.74021 7.49965 2.86739 7.49965 3C7.49965 3.13261 7.55233 3.25979 7.6461 3.35355C7.73987 3.44732 7.86705 3.5 7.99965 3.5H12.7927L2.64565 13.646C2.59917 13.6925 2.56229 13.7477 2.53713 13.8084C2.51197 13.8692 2.49902 13.9343 2.49902 14C2.49902 14.0657 2.51197 14.1308 2.53713 14.1916C2.56229 14.2523 2.59917 14.3075 2.64565 14.354C2.69214 14.4005 2.74733 14.4374 2.80807 14.4625C2.86881 14.4877 2.93391 14.5006 2.99965 14.5006C3.0654 14.5006 3.1305 14.4877 3.19124 14.4625C3.25198 14.4374 3.30717 14.4005 3.35366 14.354L13.4997 4.207V9C13.4997 9.13261 13.5523 9.25979 13.6461 9.35355C13.7399 9.44732 13.867 9.5 13.9997 9.5C14.1323 9.5 14.2594 9.44732 14.3532 9.35355C14.447 9.25979 14.4997 9.13261 14.4997 9V3Z" fill="#00BCD4"/></svg>';
  
    return readMoreLink;
  }
  
  function updateSectionTitle(sectionTitleElement) {
    if (sectionTitleElement) {
      // sectionTitleElement.innerHTML = `Latest from <span class="highlight-text">Worshiphouse</span> Blog!`;
    }
  }

  function setupScrollEndDetection() {
    const blogPostsRight = document.querySelector('.blog-posts-right');
    
    if (!blogPostsRight) {
      return;
    }

    blogPostsRight.addEventListener('scroll', function() {
      const isScrolledToEnd = this.scrollLeft >= (this.scrollWidth - this.clientWidth - 1);
      
      if (isScrolledToEnd) {
        this.classList.add('scroll-end');
      } else {
        this.classList.remove('scroll-end');
      }
    });
  }
   
 